import * as ProcessLyncFrontEndServerDataActions from '@actions/process-lync-front-end-server-data/process-lync-front-end-server-data.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { RealtimeGatewayService } from '@services/index';
import { RealTimeNotify } from '@models/index';



@Injectable()
export class ProcessLyncFrontEndServerDataEffects {

  constructor(private actions$: Actions, private realtimeGatewayService: RealtimeGatewayService) { }

  getNotifyProcessLyncFrontEndServerData$ = createEffect(() => this.actions$.pipe(
    ofType(ProcessLyncFrontEndServerDataActions.GetNotifyProcessLyncFrontEndServerData),
    switchMap((action) => this.realtimeGatewayService.observe(action.equipmentId, action.commandTypeId).pipe(
      catchError((err) => of(
        ProcessLyncFrontEndServerDataActions.GetNotifyProcessLyncFrontEndServerDataFailure({ error: err })
        )
      ),
      mergeMap((data: RealTimeNotify) => [
        ProcessLyncFrontEndServerDataActions.GetNotifyProcessLyncFrontEndServerDataSuccess({ data }),
        ProcessLyncFrontEndServerDataActions.GetProcessLyncFrontEndServerData({ ...data })
      ],
      ),
    ),
    )
  ));

  getProcessLyncFrontEndServerData$ = createEffect(() => this.actions$.pipe(
    ofType(ProcessLyncFrontEndServerDataActions.GetProcessLyncFrontEndServerData),
    mergeMap((action) => this.realtimeGatewayService.getDocument(action.equipmentId, action.commandTypeId).pipe(
      map((data) => ProcessLyncFrontEndServerDataActions.GetProcessLyncFrontEndServerDataSuccess({ data:{ data, equipmentId: action.equipmentId} }),
      ),
      catchError((err) => of(ProcessLyncFrontEndServerDataActions.GetProcessLyncFrontEndServerDataFailure({ error: err })))
    ))
  ));

}
